import React, { useState } from "react";
import { X, Eye } from "lucide-react";
import { api } from "@/lib/api";
import { ARGUS_TOKEN, aErr, Btn, Label, inputCls } from "@/components/argus/ui";

export default function ArgusLogin({ onDone, onClose }) {
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");
  const set = (k) => (e) => setF(x => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const body = mode === "login" ? { email: f.email, password: f.password } : f;
      const { data } = await api.post(`/argus/auth/${mode}`, body);
      localStorage.setItem(ARGUS_TOKEN, data.token);
      onDone(data.user);
    } catch (e2) { setErr(aErr(e2, "Sign-in failed")); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/75 backdrop-blur-md grid place-items-center px-4" data-testid="argus-login-modal">
      <form onSubmit={submit} className="w-full max-w-sm argus-glass rounded-xl p-6 bg-[#04120b]">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2"><Eye className="w-4 h-4 text-[#10b981]" /><Label>{mode === "login" ? "Sign in to Argus" : "Create your Argus account"}</Label></div>
          <button type="button" onClick={onClose} data-testid="argus-login-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="space-y-2 mt-4">
          {mode === "register" && <input className={inputCls} value={f.name} onChange={set("name")} placeholder="Your name" required data-testid="argus-login-name" />}
          <input className={inputCls} type="email" value={f.email} onChange={set("email")} placeholder="Email" required data-testid="argus-login-email" />
          <input className={inputCls} type="password" value={f.password} onChange={set("password")} placeholder={mode === "login" ? "Password" : "Password (8+ characters)"} required minLength={mode === "login" ? 1 : 8} data-testid="argus-login-password" />
        </div>
        {err && <div className="text-red-300 text-xs mt-2" data-testid="argus-login-err">{err}</div>}
        <Btn type="submit" busy={busy} className="w-full justify-center mt-4 !py-2.5 !text-sm" data-testid="argus-login-submit">{mode === "login" ? "Sign in" : "Create account"}</Btn>
        <div className="flex justify-between text-[11px] mt-3 text-white/50">
          <button type="button" className="hover:text-[#34d399]" onClick={() => { setMode(m => m === "login" ? "register" : "login"); setErr(""); }} data-testid="argus-login-toggle">{mode === "login" ? "New here? Create an account" : "Have an account? Sign in"}</button>
          {mode === "login" && <a href="/forgot-password" className="hover:text-[#34d399]" data-testid="argus-login-forgot">Forgot password?</a>}
        </div>
        <p className="text-[10px] text-white/35 mt-3">Uses your Fliboe email and password. Your Argus session stays separate from Fliboe FM.{mode === "register" && <> By creating an account you agree to the <a href="/argus/terms" target="_blank" rel="noopener noreferrer" className="underline" data-testid="argus-login-terms">Terms</a> and <a href="/argus/privacy" target="_blank" rel="noopener noreferrer" className="underline">Privacy Policy</a>.</>}</p>
      </form>
    </div>
  );
}
